import React, { Component } from 'react';

import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import Contact from '../Entity/Contact'

/**
* Class ContactList
* ContactList view component
**/
class ContactList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = Contact;

    // Filter list
    const filters = [{
      title: "Nom",
      type: "text",
      name: "nom",
      rowIdx: 1
    },{
      title: "Prénom",
      type: "text",
      name: "prenom",
      rowIdx: 1
    }];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes contacts interne</h2>
        <GridFilter title="Filtrer les contacts" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Contacts" ref={"grid" + objectClass.name} path="contacts" objectPath="contacts/?interne=true" objectClass={objectClass} height="400px" hidden={false} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["grid" + Contact.name];
    grid.applyFilter(fieldName, value);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["grid" + Contact.name];
    grid.clearFilters();
  }

}
export default ContactList;



// WEBPACK FOOTER //
// ./src/views/Search/ContactList.js